import { BRAND_COLOR_PALETTE } from "@/constants";
import { VProgressLinear } from "vuetify/components";

export const mptTheme = {
  dark: false,
  colors: {
    // surface: BRAND_COLOR_PALETTE.brandOrange02,
    "on-surface": BRAND_COLOR_PALETTE.brandViolet01,
    "surface-light": BRAND_COLOR_PALETTE.brandGrey03,
    light: BRAND_COLOR_PALETTE.brandGrey04,
    dark: BRAND_COLOR_PALETTE.brandGrey02,
    "on-light": BRAND_COLOR_PALETTE.brandViolet01,
    primary: BRAND_COLOR_PALETTE.brandOrange02,
    "on-primary": BRAND_COLOR_PALETTE.brandViolet01,
    secondary: BRAND_COLOR_PALETTE.brandOrange04,
    "on-secondary": BRAND_COLOR_PALETTE.brandViolet01,
    error: BRAND_COLOR_PALETTE.brandRed02,
    red: BRAND_COLOR_PALETTE.brandRed02,
    info: BRAND_COLOR_PALETTE.brandViolet03,
    "info-light": BRAND_COLOR_PALETTE.brandViolet04,
    blue: BRAND_COLOR_PALETTE.brandViolet03,
    success: BRAND_COLOR_PALETTE.brandGreen02,
    green: BRAND_COLOR_PALETTE.brandGreen02,
    warning: BRAND_COLOR_PALETTE.brandOrange04,
    orange: BRAND_COLOR_PALETTE.brandOrange04,
    "brand-blue-color": BRAND_COLOR_PALETTE.brandViolet02,
  },
  variables: {
    "border-color": BRAND_COLOR_PALETTE.brandGrey03,
    "border-opacity": 0.7,
    "btn-height": "40px",
    "hover-opacity": 0.13,
  },
};

export const vantaaTheme = {
  dark: mptTheme.dark,
  colors: {
    ...mptTheme.colors,
    primary: BRAND_COLOR_PALETTE.vantaaBlueDark,
    "on-primary": "#fff",
    secondary: BRAND_COLOR_PALETTE.vantaaBlue,
    "on-secondary": "#fff",
    "brand-blue-color": BRAND_COLOR_PALETTE.brandViolet04,
  },
  variables: {
    ...mptTheme.variables,
    "border-color": BRAND_COLOR_PALETTE.vantaaGreyLight,
  },
};

export const defaults = {
  VBtn: {
    variant: "flat",
  },
  VBtnCta: {
    variant: "flat",
    rounded: "xl",
    style: [
      {
        textTransform: "uppercase",
        fontWeight: "600",
        letterSpacing: "1.5px",
        // make font size a bit smaller because the caps is overwhelming
        fontSize: "0.8rem",
      },
    ],
  },
  VBtnMenu: {
    variant: "flat",
    rounded: "0",
    style: [
      {
        height: "61px",
        minWidth: "50px",
        padding: "0px 5px",
      },
    ],
  },
  VBtnToggle: {
    density: "comfortable",
    color: "primary",
    mandatory: true, // otherwise you can deselect
    divided: true, // border between btns
    class: ["border"], // btn variant needs to be flat but add border for unselected btns
    VBtn: {
      // so that the btns take up the space when e.g. toggle has width: 100%
      class: ["flex-grow-1"],
    },
  },
  VBtnGroup: {
    density: "comfortable",
    variant: "outlined",
    divided: true,
    VBtn: {
      class: ["flex-grow-1"],
    },
  },
  VChip: {
    variant: "flat",
    color: "secondary",
  },
  VTextField: {
    variant: "outlined",
    density: "compact",
    color: "brand-blue-color",
    bgColor: "white",
  },
  VSelect: {
    variant: "outlined",
    density: "compact",
    color: "brand-blue-color",
  },
  VAutocomplete: {
    variant: "outlined",
    density: "compact",
    color: "brand-blue-color",
  },
  VNumberInput: {
    variant: "outlined",
    density: "compact",
    color: "brand-blue-color",
    controlVariant: "split",
  },
  VDateInput: {
    variant: "outlined",
    density: "compact",
    color: "brand-blue-color",
    firstDayOfWeek: 1,
    showAdjacentMonths: true,
  },
  VTimePicker: {
    format: "24hr",
  },
  VRadio: {
    color: "primary",
  },
  VRadioGroup: {
    color: "primary",
  },
  VCheckbox: {
    color: "primary",
    density: "comfortable",
  },
  VCheckboxBtn: {
    color: "primary",
    density: "comfortable",
  },
  VCombobox: {
    variant: "outlined",
    density: "compact",
    color: "brand-blue-color",
  },
  VTextarea: {
    variant: "outlined",
    density: "compact",
    color: "brand-blue-color",
    bgColor: "white",
  },
  VSwitch: {
    inset: "true",
    color: "primary",
    density: "compact",
  },
  VList: {
    density: "compact",
  },
  VCard: {
    rounded: "xl",
  },
  VCardActions: {
    VBtn: {
      variant: "flat",
      slim: false,
    },
  },
  VCardTitleWrap: {
    style: [{ whiteSpace: "unset", lineHeight: "1.5rem" }],
  },
  VTabs: {
    sliderColor: "primary",
  },
  VTabsBoxed: {
    sliderColor: "transparent",
    class: ["v-tabs--boxed"],
    VTab: {
      variant: "outlined",
    },
  },
  VSlider: {
    color: "primary",
    thumbLabel: true,
    trackColor: BRAND_COLOR_PALETTE.brandGrey03,
    trackSize: 5,
  },
  VRangeSlider: {
    color: "primary",
    thumbLabel: true,
    trackColor: BRAND_COLOR_PALETTE.brandGrey03,
    trackSize: 5,
  },
  VToolbar: {
    color: "white",
  },
  VProgressLinear: {
    bgColor: "#dfdfdf",
    bgOpacity: 0.4,
  },
};
